import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Assignment from './views/Assignment.vue'
// import store from './store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/assignment/:id',
      name: 'assignment',
      component: Assignment
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   if(store.state.user || to.path == '/') {
//     return next()
//   }
//   router.push('/')
// })

export default router
